export default "images/导航.png";